export default function MasonryTypesElPaso() {
  const types = [
    {
      name: 'Traditional Stucco',
      description: 'Classic three-coat cement stucco system offering superior durability and authentic southwestern appearance.',
      material: 'Cement, Sand, Lime',
      bestFor: 'Historic homes, traditional architecture, long-term durability',
      image: 'https://public.readdy.ai/ai/img_res/c20d57a8f725e2a3233d91d04f712e5d.jpg'
    },
    {
      name: 'Synthetic Stucco (EIFS)',
      description: 'Modern exterior insulation finishing system providing excellent energy efficiency and design flexibility.',
      material: 'Foam Board, Acrylic Finish',
      bestFor: 'Energy efficiency, modern homes, decorative details',
      image: 'https://readdy.ai/api/search-image?query=Modern%20synthetic%20stucco%20EIFS%20on%20contemporary%20El%20Paso%20home%2C%20energy-efficient%20exterior%20finish%20system%2C%20clean%20smooth%20appearance%20on%20modern%20architecture%2C%20quality%20installation%20with%20insulation%20benefits%2C%20residential%20construction%20photography&width=600&height=400&seq=masonry-type-002&orientation=landscape'
    },
    {
      name: 'Natural Stone Veneer',
      description: 'Authentic natural stone creating timeless beauty and exceptional durability for distinctive architectural statements.',
      material: 'Limestone, Sandstone, Granite',
      bestFor: 'Luxury homes, accent walls, outdoor features',
      image: 'https://readdy.ai/api/search-image?query=Natural%20stone%20veneer%20on%20upscale%20El%20Paso%20home%2C%20authentic%20limestone%20and%20sandstone%20masonry%20work%2C%20beautiful%20southwestern%20architecture%20with%20quality%20stone%20installation%2C%20luxury%20residential%20exterior%20with%20natural%20materials%2C%20architectural%20photography&width=600&height=400&seq=masonry-type-003&orientation=landscape'
    },
    {
      name: 'Manufactured Stone',
      description: 'High-quality engineered stone offering natural appearance at lower cost with easier installation.',
      material: 'Concrete, Pigments',
      bestFor: 'Cost-effective beauty, quick installation, variety of styles',
      image: 'https://readdy.ai/api/search-image?query=Manufactured%20stone%20veneer%20on%20modern%20El%20Paso%20home%2C%20engineered%20stone%20with%20natural%20appearance%2C%20contemporary%20residential%20exterior%20with%20quality%20faux%20stone%2C%20cost-effective%20masonry%20installation%2C%20construction%20detail%20photography&width=600&height=400&seq=masonry-type-004&orientation=landscape'
    },
    {
      name: 'Brick Masonry',
      description: 'Traditional brick construction providing classic beauty, fire resistance, and minimal maintenance requirements.',
      material: 'Clay Brick, Mortar',
      bestFor: 'Traditional homes, commercial buildings, fire resistance',
      image: 'https://readdy.ai/api/search-image?query=Classic%20brick%20masonry%20on%20El%20Paso%20building%2C%20traditional%20red%20brick%20construction%20with%20quality%20mortar%20work%2C%20timeless%20architectural%20design%20with%20durable%20materials%2C%20professional%20bricklaying%20craftsmanship%2C%20architectural%20photography&width=600&height=400&seq=masonry-type-005&orientation=landscape'
    },
    {
      name: 'Concrete Block (CMU)',
      description: 'Structural concrete masonry units offering strength, fire resistance, and versatility for various applications.',
      material: 'Concrete Block',
      bestFor: 'Foundations, retaining walls, commercial construction',
      image: 'https://readdy.ai/api/search-image?query=Concrete%20block%20CMU%20construction%20in%20El%20Paso%2C%20structural%20masonry%20units%20for%20commercial%20building%2C%20professional%20block%20laying%20with%20quality%20materials%2C%20strong%20foundation%20and%20wall%20construction%2C%20industrial%20construction%20photography&width=600&height=400&seq=masonry-type-006&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Masonry &amp; Stucco Types for El Paso
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Choose the perfect masonry or stucco solution for your project. Each type offers unique benefits for different applications and architectural styles.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {types.map((type, index) => (
            <div key={index} className="bg-white rounded-xl overflow-hidden border-2 border-gray-200 hover:border-teal-500 transition-all">
              <div className="relative h-48 w-full">
                <img 
                  src={type.image} 
                  alt={type.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{type.name}</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">{type.description}</p>
                <div className="space-y-2 mb-4">
                  <div className="flex items-start gap-2">
                    <i className="ri-stack-line text-teal-600 mt-0.5"></i>
                    <div>
                      <p className="text-xs font-semibold text-gray-900">Materials</p>
                      <p className="text-xs text-gray-600">{type.material}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-teal-600 mt-0.5"></i>
                    <div>
                      <p className="text-xs font-semibold text-gray-900">Best For</p>
                      <p className="text-xs text-gray-600">{type.bestFor}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
